// Blockly inject オプション（旧ビルダープレビュー BlocklyOptions.ts から復元）
// theme は common/blockly のものを使用（旧版は algorithm コースから import していた）。

import Blockly from "blockly";
import { theme } from "common/blockly";
import Constants from "common/constant";

export const PreviewBlocklyOptions = (
  scale: number,
  toolbox: Blockly.utils.toolbox.ToolboxDefinition,
  maxInstances: { [type: string]: number },
) => ({
  collapse: true,
  comments: false,
  css: true,
  disable: true,
  sounds: true,
  horizontalLayout: false,
  media: `${Constants.assetHost}/assets/blockly/game/`,
  move: {
    scrollbars: false,
    drag: true,
    wheel: false,
  },
  zoom: {
    startScale: scale,
  },
  // コマンド別の使用個数上限（algorithm コースと同じ Blockly 標準機能。
  // 上限到達でフライアウトのブロックがグレーアウトしドラッグ不可になる）
  maxInstances: JSON.parse(JSON.stringify(maxInstances)),
  oneBasedIndex: true,
  readOnly: false,
  rtl: false,
  toolbox: toolbox,
  toolboxPosition: "start",
  trashcan: true,
  maxTrashcanContents: 32,
  renderer: "zelos",
  theme: theme,
});
